import React from 'react';

import ChestTile from '@swf/components/ChestTile/ChestTile';
import type { MpcChest } from '@swf/core/types/ChestInventory';
import { ChestLockedType } from '@swf/core/types/Notification';

import styles from './Grid.scss';

export interface Props {
  chests: MpcChest[];
}

const Grid: React.FC<Props> = ({ chests }) => (
  <div className={styles.mpcGrid}>
    {chests
      .filter((item) => item.isAvailable || item.lockType !== ChestLockedType.IceLocked)
      .map((item, key) => (
        <ChestTile key={`chest-${key}`} {...item} />
      ))}

    {chests
      .filter((item) => !item.isAvailable && item.lockType === ChestLockedType.IceLocked)
      .map((item: MpcChest, key) => (
        <ChestTile key={`ice-chest-${key}`} {...item} />
      ))}
  </div>
);

export default Grid;
